// Analytics utility functions
const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Generate a simple session ID
const generateSessionId = () => {
  return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

// Track website visit (once per session)
export const trackWebsiteVisit = async () => {
  try {
    // Check if visit is already tracked in this session
    if (typeof sessionStorage !== 'undefined') {
      const visitTracked = sessionStorage.getItem('visitTracked');
      if (visitTracked) {
        return; // Already tracked in this session
      }

      // Get session ID
      let sessionId = sessionStorage.getItem('sessionId');
      if (!sessionId) {
        sessionId = generateSessionId();
        sessionStorage.setItem('sessionId', sessionId);
      }

      // Track visit
      const response = await fetch(`${API_BASE}/api/analytics/visit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: sessionId,
          ip_address: null, // Server will handle this
          user_agent: navigator.userAgent,
        }),
      });

      if (response.ok) {
        sessionStorage.setItem('visitTracked', 'true');
      }
    }
  } catch (error) {
    console.error('Error tracking website visit:', error);
    // Don't fail the app if analytics fails
  }
};

// Track product view
export const trackProductView = async (productId) => {
  try {
    const response = await fetch(`${API_BASE}/api/analytics/product-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
      }),
    });
  } catch (error) {
    console.error('Error tracking product view:', error);
    // Don't fail the app if analytics fails
  }
};

// Track cart event (add to cart)
export const trackCartEvent = async (productId, quantity) => {
  try {
    const response = await fetch(`${API_BASE}/api/analytics/cart-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        product_id: productId,
        quantity: quantity,
      }),
    });
  } catch (error) {
    console.error('Error tracking cart event:', error);
    // Don't fail the app if analytics fails
  }
};
